//  ----------      START   IMPORT  BLOCK       ----------
import { useMemo } from 'react';
//  Context
import { usePatient } from './PatientContext';
//  Services
import UserPrescriptionService from '../Services/UserPrescriptionService';
//  ----------      START   IMPORT  BLOCK       ----------

export const useUserPrescriptions = () => {
  const { patient, updateSection } = usePatient();
// Safely default to {} if patient.prescriptions is null/undefined
  const prescriptions = useMemo(() => {
      return patient?.prescriptions ?? []; 
    }, [patient]); 
    
  // Safely default to [] if patient.active_prescriptions is null/undefined
  const active_prescriptions = useMemo(() => {
      return patient?.active_prescriptions ?? []; 
    }, [patient]);

  /**
   *  Read-only access to general info already stored in context (current patient).
   */
  const readUserPrescriptions = async () => {
    return prescriptions; 
  };

  const updateUserActivePrescriptions = async (dataToSend) => {
    return
  }

  /**
   * Updates general info for a patient, both in API and context.
   */
  const updateUserPrescriptions = async (dataToSend) => {
    const payload = { 
      id: patient.id, // The patient ID
      // The array of prescriptions goes here, mapped to the correct key:
      prescriptions_to_update: dataToSend 
    };
    console.log('payload', payload)
    const service = new UserPrescriptionService();
    const updated = await service.updatePrescription(payload);
    
    // Update context with latest data returned by API
    //updateSection(PATIENT_SECTIONS.ALLERGIES, updated);
    return

  };
//active_prescriptions
  return { prescriptions, active_prescriptions, readUserPrescriptions, updateUserPrescriptions, updateUserActivePrescriptions };
};